import React, { Component } from 'react';
import PropTypes from 'prop-types';
import confetti from 'canvas-confetti/src/confetti';

import { submit, isDirty } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Button from 'components/common/Button';
import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  typographyContent: {
    marginTop: 40,
    marginBottom: 40,
  },
  backdropRoot: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.common.white)}, 0.25)`,
    zIndex: '-100',
  },
});

class SignUpSuccessDialog extends Component {
  constructor(props) {
    super(props);

    this.onDialogEnter = this.onDialogEnter.bind(this);
  }

  onDialogEnter() {
    const { theme } = this.props;
    const end = Date.now() + (5 * 1000);
    const colors = [
      theme.palette.primary[500],
      theme.palette.notification[500],
      theme.palette.add[500],
      theme.palette.common.white,
    ];
    const frame = () => {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors,
        zIndex: 3000,
      });
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors,
        zIndex: 3000,
      });
      if (Date.now() < end && this.props.open) {
        window.requestAnimationFrame(frame);
      }
    };
    frame();
  }

  render() {
    const {
      open,
      onClose,
      onSubmit,
      classes,
    } = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        maxWidth="sm"
        BackdropProps={{
          classes: {
            root: classes.backdropRoot,
          },
        }}
      >
        <DialogTitle onCloseClick={onClose}>
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            Registration Succeeded!
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            className={classes.typographyContent}
            color="secondary"
            align="center"
          >
            Congratulations, your DME application has been successfully created! Now you can explore it's features, but for full functionality you need to proceed with organization set up.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="raised"
          >
            Close
          </Button>
          <Button
            onClick={onSubmit}
            variant="raised"
            color="primary"
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

SignUpSuccessDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        500: PropTypes.string.isRequired,
      }).isRequired,
      notification: PropTypes.shape({
        500: PropTypes.string.isRequired,
      }).isRequired,
      add: PropTypes.shape({
        500: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

SignUpSuccessDialog.defaultProps = {
  open: false,
  onClose: () => {},
};


export default withStyles(styles, { withTheme: true })(SignUpSuccessDialog);



// WEBPACK FOOTER //
// ./src/components/home/SignUpSuccessDialog/SignUpSuccessDialog.js